import React from 'react';
import Loader from './Loader';
import LoaderIcon from './LoaderIcon';

const ScreenLoader = () => {
  return (
    <main className=' w-screen h-screen grid grid-rows-10'>
      <div className='row-span-8 flex items-center justify-center'>
        <img src='logo512x512.png' className='w-[70px] mb-5' alt='' />
      </div>
      <div className='row-span-2 flex items-center justify-center'>
        <LoaderIcon />
      </div>
    </main>
  );
};

export default ScreenLoader;
